import { render, staticRenderFns } from "./camera-spinner.vue?vue&type=template&id=4c5017c7&scoped=true&"
import script from "./camera-spinner.vue?vue&type=script&lang=js&"
export * from "./camera-spinner.vue?vue&type=script&lang=js&"
import style0 from "./camera-spinner.vue?vue&type=style&index=0&id=4c5017c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5017c7",
  null
  
)

export default component.exports